import { appConfig } from '../../../config/customization';
import { xxsmall } from '../../../constants/fonts';

export default {
  base: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: xxsmall,
    fontWeight: 400,
    color: appConfig.colors.white,
    background: appConfig.colors.tagBase,
    borderRadius: 100,
    outline: 0,
    border: 0,
    minHeight: 20
  },
  content: {
    margin: '1px 3px 0px'
  },
  gray: {
    background: appConfig.colors.lightGray,
    color: appConfig.colors.black,
    border: 0
  },
  green: {
    background: appConfig.colors.green,
    color: appConfig.colors.white
  },
  lightGray: {
    background: appConfig.colors.lightGray,
    color: appConfig.colors.white
  },
  lightBlue: {
    background: appConfig.colors.lightBlue,
    color: appConfig.colors.white
  },
  iconStyle: {
    height: '60%',
    width: 'auto'
  },
  checkedBackground: {
    backgroundColor: appConfig.colors.checkedBackground,
    width: 15,
    height: 15,
    borderRadius: 100,
    margin: '2px 0px 2px 3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  checkedOk: {
    strokeWidth: 2.4,
    stroke: appConfig.colors.checkedOk,
    fill: 'none',
    marginRight: 2
  }
};
